import { Text, type TextProps, useWhenItWas } from "@rally/ui-kit";
import { exactWhen, friendlyWhen } from "./format.ts";

export function WhenLabel({
  at,
  color = "text.tertiary",
  typeName = "caption",
  compact = false,
  ...rest
}: {
  at: string | Date;
  compact?: boolean;
} & Pick<TextProps, "color" | "typeName" | "style" | "numberOfLines" | "testID">) {
  const whenItWas = useWhenItWas();
  return (
    <Text {...rest} typeName={typeName} color={color} {...({ title: exactWhen(at) } as object)}>
      {compact ? whenItWas(new Date(at)) : friendlyWhen(at)}
    </Text>
  );
}
